// ============================================================
// Datei: src/pages/ressorts/InfrastrukturMobile.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName + filterFn
// - Aufbau / Abbau bleiben sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";

import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./infrastrukturMobile.css";

const InfrastrukturMobile = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	activeTab,
	setActiveTab,
	reloadGuests,
	setSelectedVolunteer,
	downloadCcEmails,
	reloadVolunteers
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);
	const [helpersSubTab, setHelpersSubTab] = useState("ressort");

	// ============================================================
	// SHIFTS
	// ============================================================
	const infrastrukturAufbau = shifts.filter(
		(s) => s.shiftId >= 610 && s.shiftId <= 619
	);

	const infrastrukturAbbau = shifts.filter(
		(s) => s.shiftId >= 630 && s.shiftId <= 639
	);

	// ============================================================
	// TABS
	// ============================================================
	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{/* ================= HELPERS ================= */}
					{activeTab === "helpers" && (
						<div className="infrastruktur-mobile-helpers-panel">
							<div className="helpers-subtab-bar">
								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "ressort"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("ressort")}
								>
									Ressort
								</button>

								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "pool"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("pool")}
								>
									Helferpool
								</button>
							</div>

							{helpersSubTab === "ressort" && (
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={setSelectedVolunteer}
									reloadVolunteers={reloadVolunteers}
								/>
							)}

							{helpersSubTab === "pool" && (
								<VolunteerPool
									departmentName="Infrastruktur"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							)}
						</div>
					)}

					{/* ================= SHIFTS ================= */}
					{activeTab === "shifts" && (
						<>
							<h3 className="infrastruktur-subheading">Aufbau</h3>
							<ShiftTable
								shifts={infrastrukturAufbau}
								departmentName="Infrastruktur"
								autoRefresh={true}
								filterFn={(shift) =>
									shift.shiftId >= 610 && shift.shiftId <= 619
								}
							/>

							<h3 className="infrastruktur-subheading">Abbau</h3>
							<ShiftTable
								shifts={infrastrukturAbbau}
								departmentName="Infrastruktur"
								autoRefresh={true}
								filterFn={(shift) =>
									shift.shiftId >= 630 && shift.shiftId <= 639
								}
							/>
						</>
					)}

					{/* ================= GUESTS ================= */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}

					{/* ================= Extras ================= */}
					{activeTab === "extras" && (
						<div className="kasse-extras-panel">
							<button
								className="cc-mail-card"
								onClick={downloadCcEmails}
								type="button"
							>
								<span className="cc-mail-icon">✉️</span>
								<span className="cc-mail-text">
									<span className="cc-mail-title">
										cc E-MailListe herunterladen
									</span>
									<span className="cc-mail-subtitle">
										Für Outlook &amp; Gmail geeignet
									</span>
								</span>
							</button>
						</div>
					)}
						</div>
					</div>
			
		</>
	);
};

export default InfrastrukturMobile;